<template>
  <div class="animated fadeIn vld-parent custom-100" >
    <b-row>
      <b-col sm="12">
        <searchBar ref="searchBar"
                   :bauhof-structure="bhStructure"
                   :on-search="queryData"
        ></searchBar>
      </b-col>
    </b-row>
    <b-row class="custom-flex-1">
      <b-col sm="12">
        <auftraegeTable ref="auftraegeTable"
                        :table-data="data"
                        @page-changed="setPage"
        ></auftraegeTable>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import searchBar from '../task_series/TaskSeriesSearchbar.vue'
import auftraegeTable from '../task_series/TaskSeriesTable.vue'
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import {
  decryptAES,
} from "@/shared/crypto";



export default {
  name: "TaskSeriesVerwaltung",
  components: {
    'searchBar':searchBar, 'auftraegeTable': auftraegeTable},
  data() {
    return {
      // SearchbarProps
      loader: undefined,
      data: [],
      currentPage: 1,
      bhStructure: [],
      isBauhof: false,
      query: {
        active: true,
        searchText: "",
        groupId: 'all',
        page: 1,
      },
      afterFirstQuery: false,
    }
  },
  watch: {
    currentTab(n, o) {
      if (this.afterFirstQuery) {
        this.$refs.searchBar.searchFilter();
      }
    },
  },
  created() {
    this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
    this.$http.get(
        Server_URL+'/auftragsbuch/data/fetch'
    ).then(this.responseOkGet, this.responseError)
  },
  methods: {
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      if (response.status === 200) {
        this.bhStructure = response.body.data.bh_structure;
        this.$nextTick(() => {
          this.parseQuery()
          this.$refs.searchBar.setQuery(this.query);
          this.queryData(this.query.active,
              this.query.searchText, this.query.groupId);
        })
      } else {
        window.location = Redirect_500;
      }
    },
    parseQuery() {
      let query = this.$route.query;
      if (query.active) {
        this.query = {
          active: query.active,
          searchText: query.searchText,
          groupId: query.groupId,
          page: query.page,
        }
      }
    },
    responseOkFetch(response) {
      this.$refs.auftraegeTable.currentPage = 1;
      this.$refs.searchBar.onFirstSearch();
      if (response.status === 200) {
        let data = response.body.data;
        this.decryptData(data);
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    setPage(page) {
      this.query.page = page;
      this.$router.push({query: this.query}).then(() => {}).catch(err => {});
    },
    queryData(active, searchText, groupId) {
      this.query = {
        active: active,
        searchText: searchText,
        groupId: groupId,
        page: this.query.page,
      }
      this.$router.push({query: this.query}).then(() => {
        this.showLoader();
        this.$http.get(
            Server_URL+'/auftragsbuch/data/av/task_series/'+groupId+
            "?active="+active+
            "&search_text="+searchText
        ).then(this.responseOkFetch, this.responseError)
      }).catch(e => {
        this.showLoader();
        this.$http.get(
            Server_URL+'/auftragsbuch/data/av/task_series/'+groupId+
            "?active="+active+
            "&search_text="+searchText
        ).then(this.responseOkFetch, this.responseError)
      });
    },
    async decryptData(data) {
      for (let i = 0; i < data.length; i++) {
        data[i]._showDetails = true;
        data[i]._rowVariant = '';
        try {
          if (data[i].description !== null && data[i].description !== "") {
            data[i].description = await decryptAES(sessionStorage.getItem("aes"), data[i].description);
          }
        } catch (e) {
          //console.log(e)
        }
      }
      this.hideLoader();
      this.data = data;
      this.$nextTick(() => {
        if (!this.afterFirstQuery) {
          this.$refs.auftraegeTable.changePage(this.query.page);
        }
        this.afterFirstQuery = true;
      })
    },
  },
}
</script>

<style scoped>
::v-deep .tab-content {
  display: none !important;
}

.bauhof-border {
  border-left: 5px solid #FBFBFB;
  border-right: 5px solid #FBFBFB;
}

</style>
<style>
.toast-pre-wrap {
  white-space: pre-wrap;
}
</style>
